<section id="container">
  <app-menu></app-menu>
  <section id="main-content">
    <section [ngClass]="showWelcomeScreen ? 'welcome-wrapper' : 'wrapper'">
      <div class="header" *ngIf="!showWelcomeScreen">
        <h3 class="title" i18n="dashboard page title|The title of the dashboard page shown to authenticated users@@dashboardPageTitle">Dashboard</h3>
        <button
          type="button"
          class="btn btn-info btn-refresh-dashboard"
          (click)="onRefreshPress()"
        ><i class="fa fa-refresh"></i></button>
      </div>
      <div class="loading-wrapper" *ngIf="isFullPageLoading || isErrorPage; else normalContent">
        <i *ngIf="isFullPageLoading" class="fa fa-circle-o-notch fa-5x fa-spin"></i>
        <div *ngIf="isErrorPage" class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">{{ error.title }}</h4>
            </div>
            <div class="modal-body">
              <div class="error-message">{{ error.message }}</div>
              <pre class="error-stack mt" *ngIf="error.stack && error.stackExpanded">{{ error.stack }}</pre>
            </div>
            <div class="modal-footer" *ngIf="error.options == 'refresh'">
              <a *ngIf="error.showSetupButton" type="button" class="btn btn-outline-dark" [routerLink]="'/setup/pbiconnection'" i18n="@@hideDetailsDashboardErrorButtonLabel" i18n="@@consentErrorGoToSetupDashboardButtonLabel">Go to setup</a>
              <button *ngIf="!error.showSetupButton && error.stack && error.stackExpanded" type="button" class="btn btn-outline-dark" (click)="onToggleErrorPress()" i18n="@@hideDetailsDashboardErrorButtonLabel">Hide details</button>
              <button *ngIf="!error.showSetupButton && error.stack && !error.stackExpanded" type="button" class="btn btn-outline-dark" (click)="onToggleErrorPress()" i18n="@@showDetailsDashboardErrorButtonLabel">Expand details</button>
              <button *ngIf="!error.showSetupButton" type="button" class="btn btn-primary" (click)="onErrorRefreshPress()" i18n="@@genericRetryButton">Retry</button>
            </div>
          </div>
        </div>
      </div>
      <ng-template #normalContent>
        <div class="content" *ngIf="showWelcomeScreen">
          <app-welcome-screen
            [planData]="planData"
            (activateRedirectPress)="onActivateRedirectPress()"
          ></app-welcome-screen>
        </div>
        <div class="content" *ngIf="!showWelcomeScreen">
          <div class="card-holder row">
            <app-kpi-card
              class="col-3"
              i18n-title="total messages sent dashboard kpi title|The title of the card that has the aggregated number of total messages sent@@totalMessageSentDashboardKpi"
              title="Total messages sent"
              icon="fa-rocket"
              [value]="historyData.success"
            ></app-kpi-card>
            <app-kpi-card
              class="col-3"
              i18n-title="monthly message limit dashboard kpi title|The title of the card that has the total messages allowed@@monthlyMessageLimitDashboardKpi"
              title="Monthly message limit"
              icon="fa-envelope"
              [value]="planData.deliveriesQuantity"
            ></app-kpi-card>
            <app-kpi-card
              class="col-3"
              i18n-title="total error occured count dashboard kpi title|The title of the card that has the total errors occured count@@totalErrorCountDashboardKpi"
              title="Total errors occurred"
              icon="fa-exclamation"
              [value]="historyData.errors"
            ></app-kpi-card>
            <app-plan-card
              class="col-3"
              [value]="planData.name"
              [expiration]="planData.planExpiration"
            ></app-plan-card>
          </div>
          <div class="graph-holder row">
            <div class="col-12">
              <div class="panel report-graph">
                <div class="panel-heading">
                  <h3 class="title" i18n="report delivery graph section title at dashboard|The title of the delivery graph section at the dashboard that shows the graph of report deliveries sent@@reportDeliveryDashboardGraphTitle">Report Deliveries</h3>
                  <div class="filter-buttons">
                    <div [ngClass]="{'btn-group': true, 'open': isFilterExpanded}">
                      <button type="button" class="btn btn-sm btn-theme03" (click)="onDropdownExpandClick()">
                        <span
                          *ngIf="currentFilterLabel === 'all' || currentFilterLabel === 'All'"
                          i18n="report delivery graph current filter label all|The label shown when All is the selected filter on the report delivery graph at the dashboard@@currentlySelectedFilterAllDeliveryGraph"
                        >All</span>
                        <span
                          *ngIf="currentFilterLabel === 'Monthly'"
                          i18n="report delivery graph current filter label monthly|The label shown when All is the selected filter on the report delivery graph at the dashboard@@currentlySelectedFilterMonthlyDeliveryGraph"
                        >Monthly</span>
                        <span
                          *ngIf="currentFilterLabel === 'Current week'"
                          i18n="report delivery graph current filter label current week|The label shown when Current week is the selected filter on the report delivery graph at the dashboard@@currentlySelectedFilterCurrentWeekDeliveryGraph"
                        >Current week</span>
                        <span
                          *ngIf="currentFilterLabel === 'Current month'"
                          i18n="report delivery graph current filter label current month|The label shown when Current month is the selected filter on the report delivery graph at the dashboard@@currentlySelectedFilterCurrentMonthDeliveryGraph"
                        >Current month</span>
                      </button>
                      <button type="button" class="btn btn-sm btn-theme03 dropdown-toggle" (click)="onDropdownExpandClick()">
                        <span class="caret"></span>
                        <span class="sr-only">Toggle Dropdown</span>
                      </button>
                      <ul class="dropdown-menu" role="menu">
                        <li><button
                          class="button-as-anchor"
                          role="button"
                          type="button"
                          (click)="onChangeGroupFilterClick('this-month')"
                          i18n="dashboard task count filter current month|The label at the filter button to filter the task count graph at the dashboard by the current month@@filterCurrentMonthDeliveryGraphLabel"
                        >Current Month</button></li>
                        <li><button
                          class="button-as-anchor"
                          role="button"
                          type="button"
                          (click)="onChangeGroupFilterClick('this-week')"
                          i18n="dashboard task count filter this week|The label at the filter button to filter the task count graph at the dashboard by this week@@filterThisWeekDeliveryGraphLabel"
                        >Current Week</button></li>
                        <li><button
                          class="button-as-anchor"
                          role="button"
                          type="button"
                          (click)="onChangeGroupFilterClick('monthly')"
                          i18n="dashboard task count filter monthly|The label at the filter button to filter the task count graph at the dashboard monthly@@filterMonthlyDeliveryGraphLabel"
                        >Monthly</button></li>
                        <li class="divider"></li>
                        <li><button
                          class="button-as-anchor"
                          role="button"
                          type="button"
                          (click)="onChangeGroupFilterClick('daily')"
                          i18n="dashboard task count filter daily|The label at the filter button to filter the task count graph at the dashboard by daily@@filterDailyDeliveryGraphLabel"
                        >Reset</button></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="panel-body">
                  <app-dashboard-event-graph [type]="currentGroupName" [data]="filteredEventData" height="200"></app-dashboard-event-graph>
                </div>
              </div>
              <div class="panel last-schedules">
                <div class="panel-heading">
                  <h3 class="title" i18n="report delivery log section title at dashboard|The title of the delivery log section at the dashboard that shows the logs of previous deliveries@@reportDeliveryDashboardLogTitle">Delivery Logs</h3>
                  <span i18n="disclaimer of amount of events visible|The text that shows how many previous deliveries are in the log section of the dashboard page@@disclaimerAmountOfVisibleLogsDashboard">Showing last 20 events</span>
                  <button
                    class="btn btn-sm btn-primary btn-show-all-logs"
                    (click)="onShowAllLogsClick()"
                    i18n="show all button label|The label at the show all button that shows the options for filtering the task count graph in the dashboard@@dashboardShowAllCountGraphButtonLabel"
                  >Show all</button>
                </div>
                <div class="panel-body">
                  <table class="table table-inbox table-hover last-schedules">
                    <thead>
                      <tr>
                        <th
                          class="status"
                          i18n="dashboard delivery log column header label for status|The header text at the dashboard delivery log table for the delivery status@@dashboardDeliveryLogStatusColumnHeader"
                        >Status</th>
                        <th
                          class="name"
                          i18n="dashboard delivery log column header label for name|The header text at the dashboard delivery log table for the delivery name@@dashboardDeliveryLogNameColumnHeader"
                        >Report Name</th>
                        <th
                          class="message"
                          i18n="dashboard delivery log column header label for message|The header text at the dashboard delivery log table for the delivery message@@dashboardDeliveryLogMessageColumnHeader"
                        >Message</th>
                        <th
                          class="contact"
                          i18n="dashboard delivery log column header label for contact|The header text at the dashboard delivery log table for the delivery contact@@dashboardDeliveryLogContactColumnHeader"
                        >Contact</th>
                        <th
                          class="date"
                          i18n="dashboard delivery log column header label for date|The header text at the dashboard delivery log table for the delivery date@@dashboardDeliveryLogDateColumnHeader"
                        >Date</th>
                        <th
                          class="date"
                          i18n="last time message is open@@dashboardDeliveryLogLastOpen"
                        >Last Open</th>
                        <th
                          class="date"
                          i18n="many times message is open@@dashboardDeliveryLogCountOpen"
                        >#Open</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let history of historyData.reports.slice(0, 20); index as i">
                        <td class="status">
                          <div class="text-center" [ngbTooltip]="history.historyType" placement="left">
                            <i class="fa fa-check" *ngIf="history.historyType === 'Complete'"></i>
                            <i class="fa fa-rocket" *ngIf="history.historyType === 'Sending'"></i>
                            <i class="fa fa-exclamation" *ngIf="history.historyType === 'Error'"></i>
                          </div>
                        </td>
                        <td class="name">{{ history.name }}</td>
                        <td class="message">{{ history.message}}</td>
                        <td class="contact">{{ history.contact ? history.contact.name : '' }}</td>
                        <td class="date">
                          <span i18n="finished date prefix at dashboard delivery log table|The finished date prefix at the date column of the dashboard delivery logs@@finishedDatePrefixDashboardDeliveryLog" *ngIf="history.endDate">Finished on</span>
                          <span i18n="started date prefix at dashboard delivery log table|The started date prefix at the date column of the dashboard delivery logs@@startedDatePrefixDashboardDeliveryLog" *ngIf="!history.endDate && history.startDate">Started on</span>
                          <span *ngIf="history.endDate">{{ " " + history.endDate.toLocaleString() }}</span>
                          <span *ngIf="!history.endDate && history.startDate">{{ " " + history.startDate.toLocaleString() }}</span>
                        </td>

                        <td class="date">{{ " " + history.lastOpen1 }}</td>
                        <td class="date">{{ " " + history.countOpen1 }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </section>
  </section>
</section>
